import classNames from 'classnames';
import * as React from 'react';
import styles from './LineClamp.module.scss.js';

var LineClamp = React.memo(function (props) {
    var style = {
        display: '-webkit-box',
        WebkitLineClamp: props.lines,
        WebkitBoxOrient: 'vertical',
        color: '#eee',
    };
    return (React.createElement("div", { className: classNames(styles.base, props.className), style: style }, props.children));
});

export { LineClamp as default };
//# sourceMappingURL=LineClamp.js.map
